import React from "react";
import { Heart } from "lucide-react";

export const ReactionWall = ({ items, textColor = "#16243b" }) => {
  if (!items || items.length === 0) return null;
  return (
    <section className="max-w-[1100px] mx-auto px-6 py-12" data-testid="reaction-wall">
      <h2 className="text-2xl font-bold flex items-center gap-2" style={{ color: textColor }}><Heart size={22} className="text-rose-500" /> Gifts that made someone's day</h2>
      <p className="text-sm text-[#8a97a8] mt-1 mb-6">Real thank-you videos from people who received our gift vouchers.</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {items.map((r, i) => (
          <figure key={i} className="bg-white rounded-2xl overflow-hidden shadow-[0_8px_24px_rgba(20,30,55,0.08)]" data-testid={`reaction-wall-item-${i}`}>
            <video src={`${process.env.REACT_APP_BACKEND_URL}${r.video_url}#t=0.1`} controls playsInline preload="metadata" className="w-full aspect-[4/5] object-cover bg-black" />
            <figcaption className="px-4 py-3 text-sm">
              <span className="font-semibold" style={{ color: textColor }}>{r.name || "A happy recipient"}</span>
              {r.product_title && <span className="text-[#8a97a8]"> · {r.product_title}</span>}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};
